import { Box, Stack, SxProps, Tooltip, Typography, TypographyProps } from '@mui/material';
import DateInfoTooltip, { DateInfoTooltipProps } from 'components/Tooltip/DateInfoTooltip';
import { ReactComponent as InfoGreyIcon } from '../../assets/icon-grey-info.svg';
import MoreOptionMenu, { MoreOptionMenuProps } from 'components/Dropdown/MoreOptionSecondary';
import { ReactComponent as MoreIcon } from '../../assets/more-vertical.svg';
import LoaderComponent from 'components/Loader';
import React from 'react';

type DataInfoSecondaryProps = {
	infoCards: {
		label: string | number;
		value: string | number | React.ReactNode;
		isLoading?: boolean;
		labelProps?: TypographyProps;
		valueProps?: TypographyProps;
		width?:string;
		height?:string;
		minWidth?: string;
		maxHeight?: string;
		maxWidth?:string;
		hasTooltip?: boolean;
	}[];
	bgColor?: string;
	infoTooltip?: Omit<DateInfoTooltipProps, 'children'> | React.ReactNode;
	infoOptionMenu?: MoreOptionMenuProps;	
	isAdmin?: boolean;
	sx?: SxProps;
};

const renderValue = (
  value: string | number | React.ReactNode,
  isLoading?: boolean,
  valueProps?: TypographyProps
) => {
  if (isLoading) return <LoaderComponent size={24} />;

  if (typeof value === 'string') {
    return (
      <Typography variant="bodyValue" lineHeight="normal" {...valueProps}>
        {value}
      </Typography>
    );
  }

  return <>{value}</>;
};

const DataInfoSecondary = ({ infoCards, infoTooltip, bgColor = 'primary.main', infoOptionMenu, isAdmin, sx }: DataInfoSecondaryProps) => {
	return (
		<Box display="flex" height="100%">
			<Box py={1} px={2} display="flex" flexGrow={1} alignItems="center" bgcolor={bgColor} borderRadius="5px" sx={sx}>
				{infoCards.map(({ label, value, labelProps, valueProps, isLoading, minWidth, width, height, maxHeight, maxWidth, hasTooltip }) => (
					<Box
						key={`${label}-${value}`}
						display="flex"
						flexGrow={1}
						sx={{
							width: width ? width : undefined,
							maxWidth: maxWidth ? maxWidth : undefined,
							minWidth: width ? undefined : minWidth || 'auto',
							height: height ? height : undefined,
							maxHeight: maxHeight ? maxHeight : undefined
						}}
					>
						<Stack gap={0.5}>
							<Typography variant='bodyText' lineHeight="normal" color="text.subtle" {...labelProps}>
								{label}
							</Typography>

							{renderValue(value, isLoading, valueProps)}
							
						</Stack>
						{hasTooltip && <Tooltip title="Cost is updated daily at 4:00 PM CST">
								<InfoGreyIcon style={{
										height: '20px',
										width: '20px', marginLeft: 4
									}}/>
						</Tooltip>}
					</Box>
				))}
				<Box display="flex" alignItems="center" gap={1}>
					{!!infoTooltip && (
						React.isValidElement(infoTooltip)
							? infoTooltip
							: <DateInfoTooltip {...(infoTooltip as Omit<DateInfoTooltipProps, 'children'>)}>
								<InfoGreyIcon />
							</DateInfoTooltip>
					)}
					{!!infoOptionMenu && isAdmin && (
						<MoreOptionMenu {...infoOptionMenu} iconColor='#39ace7'>
							<MoreIcon />
						</MoreOptionMenu>
					)}
				</Box>
			</Box>
		</Box>
	);
};

export default DataInfoSecondary;
